import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Loader2 } from 'lucide-react';
import { userService } from "../../_services";

function SummaryFaq({ summaryfaq }) {
    const [userData, setUserData] = useState([]);
    const [faqData, setFaqData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
            const [userId, userName] = Usermeta_Data.split(':');
            
            setUserData(Usermeta_Data.split(':'));
            
            // Load FAQ data
            const count = summaryfaq === "5" ? '5' : '0';
            getFaqList(userId, userName, count);
        } catch (error) {
            console.error('Error loading FAQ:', error);
            setLoading(false);
        }
    }, [summaryfaq]);

    const getFaqList = async (userId, userName, count) => {
        try {
            // PRESERVE EXACT API CALL - DO NOT CHANGE
            const apidata = await userService.Get_FAQ(userId, userName, count);
            
            if (apidata && apidata.length > 0) {
                setFaqData(apidata);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching FAQ:', error);
            setLoading(false);
        }
    };

    // Check authentication
    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate replace to="/signup" />;
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-brand-accent" />
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {userData.length > 0 && faqData.length > 0 ? (
                <Card>
                    <CardHeader>
                        <CardTitle>Cashback FAQ's</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <Accordion type="single" collapsible className="w-full">
                            {faqData.map((faq, index) => (
                                <AccordionItem key={index} value={`item-${index}`}>
                                    <AccordionTrigger className="text-left">
                                        {faq.question || faq.title}
                                    </AccordionTrigger>
                                    <AccordionContent>
                                        <div 
                                            className="prose prose-sm max-w-none"
                                            dangerouslySetInnerHTML={{ __html: faq.answer || faq.content || faq.description }}
                                        />
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </CardContent>
                </Card>
            ) : (
                <Card>
                    <CardContent className="py-12 text-center text-gray-500">
                        No FAQ items available at this time.
                    </CardContent>
                </Card>
            )}
        </div>
    );
}

export default SummaryFaq;
